import { client } from '@api/client';
import { URL } from '@api/urls';

import { normalizeObject } from '@utils/common';

import { ISearchValue } from '@interfaces/common/store';
import { ICrowdCellsConfigPreset, TCrowdCellConfigPresetsResponse } from '@interfaces/crowdcell/crowdCells';
import { ICrowdCellsConfigPresetCreateDTO } from '@interfaces/crowdcell/dto/crowdCellsDTO';

const { crowdCells } = URL;

export function getCrowdCellPresets({
	searchValue,
}: ISearchValue): Promise<TCrowdCellConfigPresetsResponse> {
	return client.get(`/${crowdCells}/configs/presets`, {
		params: normalizeObject({
			searchValue,
		}),
	});
}

export function createPreset(preset: ICrowdCellsConfigPresetCreateDTO): Promise<TCrowdCellConfigPresetsResponse> {
	return client.post(`/${crowdCells}/configs/presets`, preset);
}

export function deletePreset(presetId: string): Promise<TCrowdCellConfigPresetsResponse> {
	return client.post(`/${crowdCells}/configs/presets/${presetId}/delete`, {});
}

export function updatePreset(preset: ICrowdCellsConfigPreset): Promise<TCrowdCellConfigPresetsResponse> {
	return client.post(`/${crowdCells}/configs/presets/${preset.id}/update`, preset);
}
